
import type { SVGProps } from 'react';
const SvgHarbor = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#harbor_svg__a)">
      <path
        fill="#263E6A"
        d="m21.461 18.547-1.395-2.556a.32.32 0 0 0-.279-.165h-2.763a.318.318 0 0 0 0 .634H19.3c-1.42 2.624-4.068 4.285-6.981 4.398l.001-.013v-9.656h2.624a.317.317 0 1 0 0-.634H12.32V8.099a2.814 2.814 0 0 0 2.192-4.04.318.318 0 0 0-.568.284 2.179 2.179 0 0 1-1.95 3.143c-1.202 0-2.178-.976-2.178-2.176a2.18 2.18 0 0 1 3.024-2.005.317.317 0 1 0 .248-.584 2.814 2.814 0 0 0-3.907 2.59 2.815 2.815 0 0 0 2.504 2.792v2.452H9.042a.317.317 0 1 0 0 .634h2.643v9.656l.002.014c-2.907-.111-5.55-1.764-6.974-4.375h2.186a.317.317 0 1 0 0-.634H4.187a.32.32 0 0 0-.279.165l-1.37 2.508a.317.317 0 1 0 .558.304l1.087-1.99C5.776 19.718 8.757 21.5 12 21.5c3.24 0 6.216-1.778 7.81-4.651l1.094 2.002a.318.318 0 0 0 .557-.304"
      />
    </g>
    <defs>
      <clipPath id="harbor_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgHarbor;
